import { DeleteLodgingOptionState, DeleteLodgingOptionActionTypes, DELETE_LODGING_OPTION_REQUEST, DELETE_LODGING_OPTION_SUCCESS, DELETE_LODGING_OPTION_FAILURE } from "store/reducers/lodgingOption/delete/types";

const defaultState: DeleteLodgingOptionState = {
  isLoading: false,
  errorMessage: ""
};

export default function deleteLodgingOption(state = defaultState, action: DeleteLodgingOptionActionTypes): DeleteLodgingOptionState {
  switch (action.type) {
    case DELETE_LODGING_OPTION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DELETE_LODGING_OPTION_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case DELETE_LODGING_OPTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};